import { render, staticRenderFns } from "./main-photo.vue?vue&type=template&id=72053148&scoped=true"
import script from "./main-photo.vue?vue&type=script&lang=js"
export * from "./main-photo.vue?vue&type=script&lang=js"
import style0 from "./main-photo.vue?vue&type=style&index=0&id=72053148&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72053148",
  null
  
)

export default component.exports